import React, { useEffect, useState } from "react";
import MascotSvg from "./mascot";
import Lottie from "lottie-react";
// import PatternSvg from "assets/svgs/pattern.svg";
import loader from "assets/loaders/cursorcart-loader.json";
import loaderDark from "assets/loaders/dark-cart-loader.json";

const Preloader: React.FC = () => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setToggle((prev) => !prev);
    }, 500); // Change colors every second

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed flex bg-white dark:bg-dark-base items-center justify-center h-screen inset-0 z-[9999999999999]">
      {/* loader */}
      <div className="flex items-end space-x-6">
        <div className="relative w-20 h-20">
          <MascotSvg className={`w-20 h-20 absolute -bottom-4`} />
        </div>
        <div
          className={`w-4 h-4 rounded-full ${
            toggle ? "bg-secondary" : "bg-primary dark:bg-white"
          } transition-colors duration-500`}
        />
        <div
          className={`w-4 h-4 rounded-full ${
            toggle ? "bg-primary dark:bg-white" : "bg-secondary"
          } transition-colors duration-500`}
        />
      </div>
      {/* <PatternSvg className="absolute bottom-0 w-full inset-x-0 h-auto md:hidden lg:hidden" /> */}
    </div>
  );
};

export default Preloader;

export const AILoader = () => {
  return (
    <div className="h-fit">
      <Lottie
        animationData={loader}
        loop={true}
        className="dark:hidden"
        style={{
          height: 300,
        }}
      />
      <Lottie
        animationData={loaderDark}
        loop={true}
        className="hidden dark:block"
        style={{
          height: 300,
        }}
      />
    </div>
  );
};
